var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10 10 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/video/play",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "svg-stroke",
    stroke: "#FFFFFF",
    strokeWidth: 1.3,
    cx: 25,
    cy: 25,
    r: 14.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 17.000000)",
    className: "svg-stroke",
    stroke: "#FFFFFF",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65,0.891487785 L0.65,15.7577668 C0.65,16.0864345 0.644789668,16.0833567 0.91449524,15.9395781 L13.7932359,8.51570368 C14.0721765,8.35346204 14.0721765,8.33701545 13.7950347,8.17771825 L0.913911753,0.7406401 C0.646114514,0.585899829 0.65,0.583596087 0.65,0.891487785 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ab97a47f7a6f2f9b8cf27a132081f783.svg";
export { ForwardRef as ReactComponent };